import styled from 'styled-components';

export const Skeleton = styled.div`
  padding-top: 3.75rem;
  width: 85%;
  margin: 0 auto;
`;
